import React from "react";
import {FilterItem, FilterItemProps, InputEditor, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";
import {FindingSeverity} from "../../domain/FindingSeverity";
import SoftwareLicense from "../../domain/SoftwareLicense";
import {Checkbox} from "antd";

export function createDefaultSbomProjectVersionComponentFilterValues() {
    return {severity: [], name: "", licenses: [], onlyDirect: false};
}

function SeverityItem(props: FilterItemProps) {
    return (
        <SelectEditor
            options={Object.keys(FindingSeverity).map(severity => ({
                value: severity,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>&gt;= {severity}</span>
            }))}
            multiple={false}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

interface LicensesProps extends FilterItemProps {
    licenses?: SoftwareLicense[];
}

function LicensesItem(props: LicensesProps) {
    return (
        <SelectEditor
            options={props.licenses?.map(license => ({
                value: license.licenseKey,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>{license.shortName}</span>
            }))}
            multiple={true}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function NameItem(props: FilterItemProps) {
    return (
        <InputEditor
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function OnlyDirectItem(props: FilterItemProps) {
    return (
        <Checkbox checked={props.value} onChange={value => props.onChange(value.target.checked)} />
    );
}

interface FilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    immediateMode?: boolean;
    licenses?: SoftwareLicense[];
    persistentStateIdent?: string;
}

function SbomProjectVersionComponentFilter(filterProps: FilterProps) {
    function toggleOnlyDirectFilter() {
        filterProps.onChange({
            ...filterProps.values,
            onlyDirect: !filterProps.values.onlyDirect
        });
    }

    const items: FilterItem[] = [
        {
            name: "name",
            key: "name",
            label: "Name",
            render: (props) => <NameItem {...props} />
        },
        {
            name: "severity",
            key: "severity",
            label: "Finding severity",
            render: (props) => <SeverityItem {...props} />
        },
        {
            name: "licenses",
            key: "licenses",
            label: "Licenses",
            render: (props) => <LicensesItem {...props} licenses={filterProps.licenses}/>
        },
        {
            name: "onlyDirect",
            key: "onlyDirect",
            label: "Only direct dependencies",
            labelCursor: "pointer",
            onLabelClick: toggleOnlyDirectFilter,
            render: (props) => <OnlyDirectItem {...props} />
        },
    ];

    return (
        <SearchFilter
            items={items}
            className={filterProps.className}
            values={filterProps.values}
            defaultValues={createDefaultSbomProjectVersionComponentFilterValues()}
            persistentStateIdent={filterProps.persistentStateIdent}
            defaultActiveFilterNames={["name", "severity", "onlyDirect", "licenses"]}
            immediateMode={filterProps.immediateMode}
            onChange={filterProps.onChange}
        />
    );
}

export default SbomProjectVersionComponentFilter;
